import axios from 'axios';

// Client creation

// Создаем совершенно новый axios instance С baseURL
const RUNTIME_BASE_URL = typeof window !== 'undefined' ? window.location.origin : '';

const MEGA_CLIENT = axios.create({
  baseURL: RUNTIME_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor
MEGA_CLIENT.interceptors.request.use(
  (config) => {
    // Добавляем timestamp для отслеживания (только для GET)
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _: Date.now(),
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
MEGA_CLIENT.interceptors.response.use(
  (response) => {
    // Бинарные ответы не трогаем (unwrap JSON только для object-тела)
    const rt = response.config.responseType
    if (rt === 'blob' || rt === 'arraybuffer') {
      return response
    }
    // Проверяем формат ответа API {success: true, data: ...}
    if (response.data && typeof response.data === 'object' && 'success' in response.data && response.data.success) {
      // Извлекаем фактические данные из wrapper'а
      response.data = response.data.data;
      return response;
    }
    
    // Для прямых массивов и других форматов возвращаем response как есть
    // API иногда возвращает прямые JSON массивы без wrapper'а
    return response;
  },
  (error) => {
    console.error('❌ HTTP request error:', error);
    throw error;
  }
);

// Экспортируем как default и named
export const apiClient = MEGA_CLIENT;
export default MEGA_CLIENT;
